// extracted by mini-css-extract-plugin
export default {"soldOut":"TicketSalesStatus-module__soldOut___S5OyP"};